import { keyframes } from 'styled-components/macro';

export const wave = (percent) => {
  let endTranslateNum;
  let startTranslateNum = 120;

  switch (percent) {
    case 1:
      endTranslateNum = 110;
      break;
    case 5:
      endTranslateNum = 108;
      break;
    case 10:
      endTranslateNum = 105;
      break;
    case 20:
      endTranslateNum = 100;
      break;
    case 33:
    case 33.3:
    case 40:
      endTranslateNum = 90;
      break;
    case 60:
    case 66:
    case 66.6:
      startTranslateNum = 0;
      endTranslateNum = -32;
      break;
    case 80:
      startTranslateNum = 0;
      endTranslateNum = -37;
      break;
    case 100:
      startTranslateNum = 0;
      endTranslateNum = -50;
      break;
    default:
      startTranslateNum = 120;
      endTranslateNum = 120;
      break;
  }

  return keyframes`
        0% {
            transform: translateY(${startTranslateNum}%) rotate(0deg)
            }
        100%
            {
            transform: translateY(${endTranslateNum}%) rotate(${
    percent === 0 ? 0 : 365
  }deg)
            }
        `;
};

export default wave;
